import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/advertised.svg'
import _imports_1 from '../../assets/liveGuide/drag.svg'


const _withScopeId = n => (_pushScopeId("data-v-3e407934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap select_none" }
const _hoisted_2 = { class: "mod_c_title hear" }
const _hoisted_3 = {
  key: 1,
  class: "mod"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mod_sub" }, null, -1))
const _hoisted_5 = { class: "mod_section" }
const _hoisted_6 = { class: "module" }
const _hoisted_7 = { class: "module_section" }
const _hoisted_8 = { class: "module_odd" }
const _hoisted_9 = { class: "module_odd_zate" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "cv_img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "container_in_img",
  src: _imports_0,
  style: {"width":"300px"}
}, null, -1))
const _hoisted_14 = { class: "module_primary" }
const _hoisted_15 = { class: "module_ul" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "功能开关 : ", -1))
const _hoisted_17 = { class: "section_info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "广告样式 :", -1))
const _hoisted_19 = { class: "module_ul_sm" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "group_info_inst" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span" }, " 文字内容 :", -1))
const _hoisted_23 = { class: "group_info_li" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content_third_sub" }, "链接地址 :", -1))
const _hoisted_25 = { class: "section_mentions" }
const _hoisted_26 = { class: "section_info_stv" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content_third_sub" }, "背景颜色 :", -1))
const _hoisted_28 = { class: "color_install" }
const _hoisted_29 = { class: "color_install_pattern color_install_patterns" }
const _hoisted_30 = { class: "pattern_name" }
const _hoisted_31 = {
  key: 1,
  class: "img_box"
}
const _hoisted_32 = { class: "filter_li_first" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group_info_span" }, "上传图片 :", -1))
const _hoisted_34 = { class: "text_upload" }
const _hoisted_35 = { class: "content_third" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content_third_sub" }, "链接地址 :", -1))
const _hoisted_37 = { class: "section_mentions_sav" }
const _hoisted_38 = { class: "mover" }
const _hoisted_39 = { class: "group_last" }
const _hoisted_40 = { class: "table_btn" }
const _hoisted_41 = { class: "module_section" }
const _hoisted_42 = { class: "module_odd" }
const _hoisted_43 = { class: "module_odd_zate" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "cv_img" }
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "container_in_img",
  src: _imports_0,
  style: {"width":"300px"}
}, null, -1))
const _hoisted_48 = { class: "module_primary" }
const _hoisted_49 = { class: "module_ul" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "功能开关 : ", -1))
const _hoisted_51 = { class: "full_screen" }
const _hoisted_52 = { style: {"display":"inline-flex"} }
const _hoisted_53 = {
  key: 0,
  class: "title_right"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "full_screen_first" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_right" }, "移动端图片 :", -1))
const _hoisted_57 = { class: "text_uploadl_sub" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "full_screen_zant" }, [
  /*#__PURE__*/_createElementVNode("p", null, "建议图片尺寸1125x2346px；"),
  /*#__PURE__*/_createElementVNode("p", null, "大小2M以内；支持PNG、JPEG、GIF")
], -1))
const _hoisted_59 = { class: "content_third_in" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "full_screen_span title_right" }, "链接地址 :", -1))
const _hoisted_61 = { class: "section_mentions_savs" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "观众进入直播间立即弹出广告 :", -1))
const _hoisted_63 = { class: "full_screen_first" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传图片 :", -1))
const _hoisted_65 = { class: "text_uploadl_sub" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "full_screen_zant" }, [
  /*#__PURE__*/_createElementVNode("p", null, "建议图片尺寸620x880px；"),
  /*#__PURE__*/_createElementVNode("p", null, "大小2M以内；支持PNG、JPEG、GIF")
], -1))
const _hoisted_67 = { class: "content_third_in" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "full_screen_span" }, "链接地址 :", -1))
const _hoisted_69 = { class: "section_mentions_savs" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "观众进入直播间立即弹出广告 :", -1))
const _hoisted_71 = { class: "full_screen_first" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提示标题 :", -1))
const _hoisted_73 = { class: "content_third_in" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "full_screen_span" }, "提示内容 :", -1))
const _hoisted_75 = { class: "full_screen_domain" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "观众进入直播间立即弹出广告 :", -1))
const _hoisted_77 = { class: "mover" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_80 = [
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = { class: "group_last" }
const _hoisted_82 = { class: "table_btn mar_left" }
const _hoisted_83 = { style: {"width":"1000px","margin-top":"50px","margin-bottom":"14px"} }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 2,
  style: {"height":"35px","overflow":"hidden","margin":"0"}
}

import Crumb from '@/components/Crumb.vue';
import CUpload from '@/components/CUpload.vue';
import { ref, reactive, watch, nextTick, computed, getCurrentInstance, unref, inject } from 'vue';
import { Switch, Tabs, Radio, message, Mentions, Input, Modal, Table, Image, notification } from 'ant-design-vue';
import { PlusOutlined } from '@ant-design/icons-vue';
import { ElColorPicker } from 'element-plus';
import http from '@/api/advertising';
import router from '@/router';
import { VueDraggableNext } from 'vue-draggable-next';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import CDelModal from '@/components/CDelModal.vue';
import { getToken } from '@/plugins/cookie';
import { dragDrop } from '@/utils/format/dragDrop';
import { LiveInfo } from '@/store/modules/live/types';
import CLoading from '@/components/CLoading.vue';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';

interface elasticAdList {
  content: string;
  id?: number;
  elastic_status: string;
  link_url: string;
  title: string;
  type: string;
  pc_image_url: string;
  loading?: boolean;
  loading1?: boolean;
  loading2?: boolean;
}
// 中部广告 intermediate_ad_list
interface intermediateList {
  bg_color: string;
  content: string;
  id?: number;
  link_url: string;
  type: string;
  loading?: boolean;
}
// interface topList {}
// 获取数据对象类型
interface advertContent {
  elastic_ad_list: elasticAdList[];
  elastic_status: number;
  id?: number;
  intermediate_ad_list: intermediateList[];
  intermediate_status: number;
  status: number;
  top_ad_list: [];
  top_status: number;
}
// S-开关
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

// E-上传照片

const __default__ = { name: 'Advertising' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const liveInfo = computed(() => unref(inject('liveInfo')) as LiveInfo);
const draggable = VueDraggableNext;
const liveBroadcastingRoomId = router.currentRoute.value.params.studioId;
const aSwitch = Switch;
const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aMentions = Mentions;
const aImage = Image;
const aMentionsOption = Mentions.Option;
// const aCarousel = Carousel;
const aTextarea = Input.TextArea;
const aModal = Modal;
const aTable = Table;
const activeKey = ref('1');

// const imgText = ref('2');
// [ElColorPicker.name]: ElColorPicker,
// 弹窗广告  elastic_ad_list
const state = reactive({
  checkStatus: false,
  checkCenterStatus: false, //中部广告开关
  checktopStatus: false, // 顶部 状态
  checkEjectStatus: false, //弹窗 状态
});
// 弹窗  数据
const elastic_ad = ref<elasticAdList[]>([
  {
    content: '',
    elastic_status: '0',
    link_url: 'http://',
    title: '',
    type: '0',
    pc_image_url: '',
  },
]);
//中部广告 数据 数组
const intermediate_ad = ref<intermediateList[]>([
  {
    bg_color: '#00CCB0',
    content: '',
    link_url: 'http://',
    type: '2',
  },
]);
const top_ad = ref();
const AdvertContentObj = ref<advertContent>({
  elastic_ad_list: elastic_ad.value,
  elastic_status: state.checkEjectStatus ? 1 : 0,
  intermediate_ad_list: intermediate_ad.value,
  intermediate_status: state.checkCenterStatus ? 1 : 0,
  status: state.checkStatus ? 1 : 0,
  top_ad_list: [],
  top_status: state.checktopStatus ? 1 : 0,
});

// 获取直播间广告内容
const loading = ref(false);
const getAdvertContent = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
  };
  loading.value = true;
  http
    .get_ad_content({ params: data })
    .then((res) => {
      AdvertContentObj.value = res.data.data;
      top_ad.value = res.data.data.top_ad_list;
      const elData = res.data.data.elastic_ad_list;
      if (elData.length > 0) {
        elastic_ad.value = elData.map((e: any) => {
          e.type = e.type.toString();
          e.elastic_status = e.elastic_status.toString();
          return e;
        });
      }

      const arr = res.data.data.intermediate_ad_list;
      if (arr.length > 0) {
        intermediate_ad.value = arr.map((e: any) => {
          e.type = e.type ? '2' : '0';
          return e;
        });
      }
      state.checkStatus = AdvertContentObj.value?.status ? true : false;
      state.checktopStatus = AdvertContentObj.value?.top_status ? true : false;
      state.checkCenterStatus = AdvertContentObj.value?.intermediate_status ? true : false;
      state.checkEjectStatus = AdvertContentObj.value?.elastic_status ? true : false;
    })
    .finally(() => (loading.value = false));
};
getAdvertContent();
//修改直播间广告内容

const updatAdvertData = useDebounce(() => {
  const arr = JSON.stringify(intermediate_ad.value);
  const newArr = JSON.parse(arr);
  // newArr.forEach((item: any, index: any) => {
  // if (item.content === '') {
  //   newArr.splice(index, 1);
  //   return false;
  // }
  // });
  const arr2 = JSON.stringify(elastic_ad.value);
  const newArr2 = JSON.parse(arr2);
  // newArr2.forEach((item: any, index: any) => {
  // if (item.content === '') {
  //   newArr2.splice(index, 1);
  // }
  // });
  const arr3 = JSON.stringify(top_ad.value);
  const newArr3 = JSON.parse(arr3);
  newArr3.forEach((item: any, index: any) => {
    if (item.content === '') {
      newArr3.splice(index, 1);
    }
  });
  const content = { intermediate_ad: newArr, top_ad: newArr3, elastic_ad: newArr2 };
  const data = {
    studio_id: liveBroadcastingRoomId,
    status: state.checkStatus ? 1 : 0,
    intermediate_status: state.checkCenterStatus ? 1 : 0,
    elastic_status: state.checkEjectStatus ? 1 : 0,
    top_status: state.checktopStatus ? 1 : 0,
    content: JSON.stringify(content),
  };
  http
    .update_or_insert_studio_ad(data)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
});
watch(intermediate_ad, async () => {
  await nextTick();
});
// 拖拽
const dragOptions = {
  animation: 0,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
};
// 轮播
// const onChange = (current: number) => {
//   console.log(current);
// };
// 中部广告类型 图片 文字
// const centralTypechange = (item: any) => {
//   item.content = '';
//   console.log(item);
// };

// const SampleText = ref('1');
// const domain = ref<string>('');
// S-链接地址
// 一
const link = ref<string>('http://123');
watch(link, () => {
  // console.log('value', link);
});
// const onSelect = (option: { link: string }) => {
//   console.log('select', option);
// };
// 二
const linkin = ref<string>('http://123');
watch(linkin, () => {
  // console.log('value', linkin);
});
// const onSelectl = (option: { linkin: string }) => {
//   console.log('select', option);
// };
// E-链接地址

const written = () => {
  //   // a.value = e;
  //   // console.log(text.value);
  //   //  show=false;
};

//S- 上传图片
const fileList = ref();
// 中部 上传图片
const handleChange = (info: FileInfo, index: number) => {
  if (info.file.status === 'uploading') {
    intermediate_ad.value[index].loading = true;
    return;
  } else intermediate_ad.value[index].loading = false;
  if (info.file?.response?.code === 200) {
    intermediate_ad.value[index].content = info.file?.response.data.url;
    message.destroy();
    message.success(info.file?.response?.message);
  } else if (info.file.status === 'error') {
    message.destroy();
    message.error(info.file?.response?.error);
  }
};

//  弹窗 全屏 浮窗 上传
const elasticHandleChange = (info: FileInfo, index: number, keywords: string) => {
  if (info.file.status === 'uploading') {
    if (keywords === 'headImg') {
      elastic_ad.value[index].loading = true;
    } else if (keywords === 'headImgM') {
      elastic_ad.value[index].loading1 = true;
    } else if (keywords === 'pcImg') {
      elastic_ad.value[index].loading2 = true;
    }
  } else {
    elastic_ad.value[index].loading = false;
    elastic_ad.value[index].loading1 = false;
    elastic_ad.value[index].loading2 = false;
  }
  if (info.file?.response?.code === 200) {
    if (keywords === 'pcImg') {
      elastic_ad.value[index].pc_image_url = info.file?.response.data.url;
    } else elastic_ad.value[index].content = info.file?.response.data.url;
    message.destroy();
    message.success(info.file?.response?.message);
  } else if (info.file.status === 'error') {
    message.destroy();
    message.error(info.file?.response?.error);
  }
};
const imageDel = (info: any, index: number, num: number) => {
  if (num === 0) {
    intermediate_ad.value[index].content = '';
  } else if (num === 1) {
    elastic_ad.value[index].content = '';
  } else if (num === 2) {
    elastic_ad.value[index].content = '';
  } else if (num === 3) {
    elastic_ad.value[index].pc_image_url = '';
  }
};

// S-中部广告添加
const addCenterSpot = () => {
  intermediate_ad.value.push({
    bg_color: '#00CCB0',
    content: '',
    link_url: 'http://',
    type: '2',
  });
};
// S-中部广告删除
const delVisible = ref<boolean>(false);
const delIndex = ref();
const closeCenter = (i: number) => {
  delIndex.value = i;
  delVisible.value = true;
};
// 删除
const openDelModal = () => {
  delVisible.value = !delVisible.value;
};
// 确定删除
const okDelModal = () => {
  activeKey.value == '1'
    ? intermediate_ad.value.splice(delIndex.value, 1)
    : activeKey.value == '3'
    ? elastic_ad.value.splice(delIndex.value, 1)
    : '';
  openDelModal();
};

// S-顶部功能添加
// const give = () => {
//   advertising.push({
//     link: 'http://123',
//     image: '',
//   });
// };
// S-顶部功能关闭
// const lose = (i: number) => {
//   advertising.splice(i, 1);
// };

// S-弹窗广告功能添加
const addElastic = () => {
  elastic_ad.value.push({
    content: '',
    elastic_status: '0',
    link_url: 'http://',
    title: '',
    type: '0',
    pc_image_url: '',
  });
};
// S-弹窗广告功能删除
const closeElastic = (i: number) => {
  delIndex.value = i;
  delVisible.value = true;
};

const record_columns = ref([
  {
    title: '广告栏图片/文字/标题',
    align: 'left',
    dataIndex: 'content',
    width: '400px',
    slots: {
      customRender: 'content',
    },
  },
  {
    title: '链接地址/内容',
    align: 'left',
    width: '300px',
    dataIndex: 'link_url',
    slots: {
      customRender: 'link_url',
    },
  },
  {
    title: '点击次数(PV)',
    align: 'left',
    dataIndex: 'pv',
  },
]);
const recordList = ref([]);
const recordVisible = ref<boolean>(false);
const showLoading = ref<boolean>(false);
const token = getToken();
const { proxy }: any = getCurrentInstance();
// 数据记录
const openModal = () => {
  recordVisible.value = true;
  getAdClickList();
};
const getAdClickList = () => {
  let params = {
    studio_id: liveBroadcastingRoomId,
  };
  showLoading.value = true;
  http
    .getAdClickList({ params: params })
    .then((res) => {
      recordList.value = res.data.data;
      showLoading.value = false;
    })
    .catch((res) => {
      showLoading.value = false;
    });
};
// 导出
const corn = ref(1);
const messageTip = ref();
const exportRecord = useDebounce((type: any) => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    type: type,
    is_cron_download: corn.value,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};
// const dragDrop = (ev: any) => {
//   ev.stopPropagation();
//   ev.preventDefault();
//   ev.dataTransfer = ev.originalEvent.dataTransfer;
// };

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 广告栏设置 "),
        _createVNode(_unref(aSwitch), {
          class: "btns_txt",
          checked: state.checkStatus,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((state.checkStatus) = $event)),
          onChange: _unref(updatAdvertData)
        }, null, 8, ["checked", "onChange"])
      ]),
      (loading.value)
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "record_btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("数据记录>")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aTabs), {
                  type: "card",
                  activeKey: activeKey.value,
                  "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => ((activeKey).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aTabPane), {
                      key: "1",
                      tab: "中部广告"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_van_swipe, {
                                class: "my-swipe",
                                autoplay: 3000,
                                "indicator-color": "white",
                                "show-indicators": false
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intermediate_ad.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
                                      default: _withCtx(() => [
                                        (item.type === '2')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "swipe-content",
                                              style: _normalizeStyle({ background: item.bg_color })
                                            }, _toDisplayString(item.content), 5))
                                          : _withDirectives((_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: item.content,
                                              style: {"width":"278px","margin":"0"}
                                            }, null, 8, _hoisted_10)), [
                                              [_vShow, item.content]
                                            ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              _withDirectives(_createElementVNode("img", {
                                src: _unref(liveInfo).image_player_cover_url,
                                style: {"width":"100%","height":"100%"}
                              }, null, 8, _hoisted_12), [
                                [_vShow, _unref(liveInfo).image_player_cover_url]
                              ])
                            ]),
                            _hoisted_13
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("ul", _hoisted_15, [
                              _createElementVNode("li", null, [
                                _hoisted_16,
                                _createVNode(_unref(aSwitch), {
                                  size: "small",
                                  class: "nav_switch",
                                  checked: state.checkCenterStatus,
                                  "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((state.checkCenterStatus) = $event))
                                }, null, 8, ["checked"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_unref(draggable), _mergeProps({
                                handle: ".mover",
                                list: intermediate_ad.value
                              }, dragOptions, {
                                disabled: intermediate_ad.value.length < 1,
                                onDrop: _unref(dragDrop)
                              }), {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intermediate_ad.value, (item, index) => {
                                    return (_openBlock(), _createElementBlock("ul", {
                                      class: "group_info",
                                      key: index
                                    }, [
                                      _createElementVNode("li", null, [
                                        _hoisted_18,
                                        _createVNode(_unref(aRadioGroup), {
                                          name: "radioGroup",
                                          class: "table_radio",
                                          onChange: ($event: any) => (item.content = ''),
                                          value: item.type,
                                          "onUpdate:value": ($event: any) => ((item.type) = $event)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(aRadio), { value: "2" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("文字")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(aRadio), { value: "0" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("图片 ")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onChange", "value", "onUpdate:value"]),
                                        _withDirectives(_createElementVNode("span", _hoisted_19, "图片尺寸1125x120；大小2M以内；支持PNG、JPEG、GIF", 512), [
                                          [_vShow, item.type === '0']
                                        ])
                                      ]),
                                      (item.type === '2')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createElementVNode("li", _hoisted_21, [
                                              _hoisted_22,
                                              _createVNode(_component_a_input, {
                                                placeholder: "请输入文字内容",
                                                value: item.content,
                                                "onUpdate:value": ($event: any) => ((item.content) = $event)
                                              }, null, 8, ["value", "onUpdate:value"])
                                            ]),
                                            _createElementVNode("li", _hoisted_23, [
                                              _hoisted_24,
                                              _createElementVNode("div", _hoisted_25, [
                                                _createVNode(_component_a_input, {
                                                  placeholder: "http://",
                                                  value: item.link_url,
                                                  "onUpdate:value": ($event: any) => ((item.link_url) = $event)
                                                }, null, 8, ["value", "onUpdate:value"])
                                              ])
                                            ]),
                                            _createElementVNode("li", _hoisted_26, [
                                              _hoisted_27,
                                              _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, [
                                                  _createElementVNode("div", _hoisted_30, _toDisplayString(item.bg_color), 1),
                                                  _createVNode(_unref(ElColorPicker), {
                                                    modelValue: item.bg_color,
                                                    "onUpdate:modelValue": ($event: any) => ((item.bg_color) = $event),
                                                    size: "mini"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                ])
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.type === '0')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createElementVNode("li", _hoisted_32, [
                                              _hoisted_33,
                                              _createElementVNode("div", _hoisted_34, [
                                                _createVNode(CUpload, {
                                                  "file-list": fileList.value,
                                                  "handle-change": (info) => handleChange(info, index),
                                                  loading: item.loading,
                                                  "image-name": item.content,
                                                  "upload-text": false,
                                                  "click-stop": (info) => imageDel(info, index, 0),
                                                  class: "ant_upload_img1"
                                                }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                                              ])
                                            ]),
                                            _createElementVNode("li", _hoisted_35, [
                                              _hoisted_36,
                                              _createElementVNode("div", _hoisted_37, [
                                                _createVNode(_unref(aMentions), {
                                                  value: item.link_url,
                                                  "onUpdate:value": ($event: any) => ((item.link_url) = $event)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(aMentionsOption), { value: "HTTP://123" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("HTTP://123")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value", "onUpdate:value"])
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", null, [
                                        (intermediate_ad.value.length > 1)
                                          ? (_openBlock(), _createBlock(_component_a_button, {
                                              key: 0,
                                              shape: "circle",
                                              onClick: ($event: any) => (closeCenter(index)),
                                              class: "postion"
                                            }, {
                                              icon: _withCtx(() => [
                                                _createVNode(_component_svg_icon, {
                                                  "icon-class": "whiteList_del",
                                                  class: "closeimg"
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _withDirectives(_createElementVNode("span", _hoisted_38, [
                                        _createVNode(_component_svg_icon, { "icon-class": "drag_icon" })
                                      ], 512), [
                                        [_vShow, intermediate_ad.value.length > 1]
                                      ])
                                    ]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 16, ["list", "disabled", "onDrop"]),
                              _createElementVNode("ul", _hoisted_39, [
                                _createElementVNode("li", _hoisted_40, [
                                  _createVNode(_component_a_button, {
                                    shape: "circle",
                                    class: "create_bot_bor create_bot_but",
                                    onClick: addCenterSpot
                                  }, {
                                    icon: _withCtx(() => [
                                      _createVNode(_unref(PlusOutlined))
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(aTabPane), {
                      key: "3",
                      tab: "弹窗广告"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_van_swipe, {
                                class: "my-swipe",
                                autoplay: 3000,
                                "indicator-color": "white",
                                "show-indicators": false
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intermediate_ad.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
                                      default: _withCtx(() => [
                                        (item.type === '2')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "swipe-content",
                                              style: _normalizeStyle({ background: item.bg_color })
                                            }, _toDisplayString(item.content), 5))
                                          : _withDirectives((_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: item.content,
                                              style: {"width":"278px","margin":"0"}
                                            }, null, 8, _hoisted_44)), [
                                              [_vShow, item.content]
                                            ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              (_unref(liveInfo).image_player_cover_url)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _unref(liveInfo).image_player_cover_url,
                                    style: {"width":"100%","height":"100%"}
                                  }, null, 8, _hoisted_46))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_47
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("ul", _hoisted_49, [
                              _createElementVNode("li", null, [
                                _hoisted_50,
                                _createVNode(_unref(aSwitch), {
                                  size: "small",
                                  class: "nav_switch",
                                  checked: state.checkEjectStatus,
                                  "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((state.checkEjectStatus) = $event))
                                }, null, 8, ["checked"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createVNode(_unref(draggable), _mergeProps({
                                handle: ".mover",
                                list: elastic_ad.value
                              }, dragOptions, {
                                disable: elastic_ad.value.length < 1,
                                onDrop: _unref(dragDrop)
                              }), {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elastic_ad.value, (item, index) => {
                                    return (_openBlock(), _createElementBlock("ul", {
                                      class: "full_screen_ul",
                                      key: index
                                    }, [
                                      _createElementVNode("li", _hoisted_52, [
                                        (item.type === '0')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, "广告样式 :"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_54, "广告样式 :")),
                                        _createVNode(_unref(aRadioGroup), {
                                          name: "radioGroup",
                                          class: "table_radio",
                                          onChange: ($event: any) => (item.content = ''),
                                          value: item.type,
                                          "onUpdate:value": ($event: any) => ((item.type) = $event)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(aRadio), { value: "0" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("全屏广告 ")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(aRadio), { value: "1" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("浮窗广告")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(aRadio), { value: "2" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("提示广告")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onChange", "value", "onUpdate:value"])
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("li", _hoisted_55, [
                                          _hoisted_56,
                                          _createElementVNode("div", _hoisted_57, [
                                            _createVNode(CUpload, {
                                              "file-list": fileList.value,
                                              "handle-change": (info) => elasticHandleChange(info, index, 'headImg'),
                                              loading: item.loading,
                                              "image-name": item.content,
                                              "upload-text": false,
                                              "click-stop": (info) => imageDel(info, index, 1),
                                              class: "ant_upload_img2"
                                            }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
                                            _hoisted_58
                                          ])
                                        ]),
                                        _createElementVNode("li", _hoisted_59, [
                                          _hoisted_60,
                                          _createElementVNode("div", _hoisted_61, [
                                            _createVNode(_unref(aMentions), {
                                              value: item.link_url,
                                              "onUpdate:value": ($event: any) => ((item.link_url) = $event),
                                              placeholder: "http://"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(aMentionsOption), { value: "HTTP://123" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("HTTP://123")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "onUpdate:value"])
                                          ])
                                        ]),
                                        _createElementVNode("li", null, [
                                          _hoisted_62,
                                          _createVNode(_unref(aRadioGroup), {
                                            name: "radioGroup",
                                            class: "table_radio",
                                            onChange: written,
                                            value: item.elastic_status,
                                            "onUpdate:value": ($event: any) => ((item.elastic_status) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(aRadio), { value: "1" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("开")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(aRadio), { value: "0" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("关")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "onUpdate:value"])
                                        ])
                                      ], 512), [
                                        [_vShow, item.type === '0']
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("li", _hoisted_63, [
                                          _hoisted_64,
                                          _createElementVNode("div", _hoisted_65, [
                                            _createVNode(CUpload, {
                                              "file-list": fileList.value,
                                              "handle-change": (info) => elasticHandleChange(info, index, 'headImgM'),
                                              loading: item.loading1,
                                              "image-name": item.content,
                                              "upload-text": false,
                                              "click-stop": (info) => imageDel(info, index, 2),
                                              class: "ant_upload_img"
                                            }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
                                            _hoisted_66
                                          ])
                                        ]),
                                        _createElementVNode("li", _hoisted_67, [
                                          _hoisted_68,
                                          _createElementVNode("div", _hoisted_69, [
                                            _createVNode(_unref(aMentions), {
                                              value: item.link_url,
                                              "onUpdate:value": ($event: any) => ((item.link_url) = $event),
                                              placeholder: "http://"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(aMentionsOption), { value: "HTTP://123" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("HTTP://123")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "onUpdate:value"])
                                          ])
                                        ]),
                                        _createElementVNode("li", null, [
                                          _hoisted_70,
                                          _createVNode(_unref(aRadioGroup), {
                                            name: "radioGroup",
                                            class: "table_radio",
                                            onChange: written,
                                            value: item.elastic_status,
                                            "onUpdate:value": ($event: any) => ((item.elastic_status) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(aRadio), { value: "1" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("开")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(aRadio), { value: "0" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("关")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "onUpdate:value"])
                                        ])
                                      ], 512), [
                                        [_vShow, item.type === '1']
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("li", _hoisted_71, [
                                          _hoisted_72,
                                          _createVNode(_component_a_input, {
                                            class: "full_screen_input",
                                            placeholder: "请输入提示标题",
                                            value: item.title,
                                            "onUpdate:value": ($event: any) => ((item.title) = $event)
                                          }, null, 8, ["value", "onUpdate:value"])
                                        ]),
                                        _createElementVNode("li", _hoisted_73, [
                                          _hoisted_74,
                                          _createElementVNode("div", _hoisted_75, [
                                            _createVNode(_unref(aTextarea), {
                                              value: item.content,
                                              "onUpdate:value": ($event: any) => ((item.content) = $event),
                                              showCount: "",
                                              class: "area_tex",
                                              maxlength: 80,
                                              placeholder: "请输入提示文字",
                                              defaultValue: "1",
                                              "auto-size": { minRows: 5, maxRows: 5 }
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ])
                                        ]),
                                        _createElementVNode("li", null, [
                                          _hoisted_76,
                                          _createVNode(_unref(aRadioGroup), {
                                            name: "radioGroup",
                                            class: "table_radio",
                                            onChange: written,
                                            value: item.elastic_status,
                                            "onUpdate:value": ($event: any) => ((item.elastic_status) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(aRadio), { value: "1" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("开")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(aRadio), { value: "0" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("关")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "onUpdate:value"])
                                        ])
                                      ], 512), [
                                        [_vShow, item.type === '2']
                                      ]),
                                      (elastic_ad.value.length > 1)
                                        ? (_openBlock(), _createBlock(_component_a_button, {
                                            key: 0,
                                            shape: "circle",
                                            onClick: ($event: any) => (closeElastic(index)),
                                            class: "postion"
                                          }, {
                                            icon: _withCtx(() => [
                                              _createVNode(_component_svg_icon, {
                                                "icon-class": "whiteList_del",
                                                class: "closeimg"
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _withDirectives(_createElementVNode("span", _hoisted_77, _hoisted_80, 512), [
                                        [_vShow, elastic_ad.value.length > 1]
                                      ])
                                    ]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 16, ["list", "disable", "onDrop"]),
                              _createElementVNode("ul", _hoisted_81, [
                                _createElementVNode("li", _hoisted_82, [
                                  _createVNode(_component_a_button, {
                                    shape: "circle",
                                    class: "create_bot_bor create_bot_but",
                                    onClick: addElastic
                                  }, {
                                    icon: _withCtx(() => [
                                      _createVNode(_unref(PlusOutlined))
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"]),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    class: "table_button",
                    onClick: _unref(updatAdvertData)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ])),
      _createVNode(CDelModal, {
        visible: delVisible.value,
        centered: "",
        close: openDelModal,
        ok: okDelModal
      }, null, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((recordVisible).value = $event)),
        title: "数据记录",
        width: 900,
        centered: "",
        okText: "导出",
        onOk: _cache[6] || (_cache[6] = ($event: any) => (_unref(exportRecord)(14)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(aTable), {
            loading: showLoading.value,
            columns: record_columns.value,
            "data-source": recordList.value,
            pagination: false,
            class: "table-list",
            rowKey: 
          (res,index) => {
            return index;
          }
        
          }, {
            content: _withCtx(({ record }) => [
              (record.type == 2 && record.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(record.title), 1))
                : (record.type == 2 && !record.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(record.content), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_86, [
                      _createVNode(_unref(aImage), {
                        src: record.content,
                        alt: "",
                        style: {"width":"100%","height":"auto"}
                      }, null, 8, ["src"])
                    ]))
            ]),
            _: 1
          }, 8, ["loading", "columns", "data-source", "rowKey"])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})